// ---------------------------------------------------------------------------
// Abrir o link no navegador certo para instalar o app: iPhone → Safari,
// Android → Chrome. Também copia o link, para quando o atalho não abre.
// Nada aqui toca no banco — é só navegação e área de transferência.
// ---------------------------------------------------------------------------

// iOS 17+: o esquema x-safari- reabre o mesmo endereço no Safari de verdade.
export function abrirNoSafari(): void {
  window.location.href = 'x-safari-' + window.location.href;
}

// Android: intent que entrega o link para o Chrome (com volta ao navegador
// atual caso o Chrome não esteja instalado).
export function abrirNoChrome(): void {
  const { host, pathname, search } = window.location;
  window.location.href =
    'intent://' + host + pathname + search + '#Intent;scheme=https;package=com.android.chrome;end';
}

export async function copiarLinkAtual(): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(window.location.href);
    return true;
  } catch {
    return false;
  }
}